import { useNavigate } from 'react-router-dom'

import { Box, Button, Icon, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

export const OverviewEmptyState = ({ trainingId }: { trainingId: string }) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  return (
    <Box alignItems="center" justifyContent="center" gap="s24" paddingTop="s40">
      <Box gap="s12" alignItems="center" justifyContent="center">
        <Icon.Large icon="add-block" />
        <Box textAlign="center" gap="s8">
          <Text size="300" weight="semibold" color="grey800">
            {i18n.t(
              'trainings.trainings_revamp.training_detail.overview.empty_state.reviewed_copies.title'
            )}
          </Text>
          <Text size="200" weight="normal" color="grey800">
            {i18n.t(
              'trainings.trainings_revamp.training_detail.overview.empty_state.reviewed_copies.description'
            )}
          </Text>
        </Box>
      </Box>
      <Button
        type="secondary"
        iconName="add"
        onClick={() =>
          navigate(
            navigation.trainings.list.details_revamp.editTraining.view.fullPath({
              id: trainingId,
            }),
            { state: { from: location.pathname } }
          )
        }
      >
        {i18n.t('trainings.trainings_revamp.training_detail.overview.empty_state.add_information')}
      </Button>
    </Box>
  )
}
